import { useNavigate, useSearchParams } from "react-router-dom";
import TaskModal from "./components/TaskModal";
import { createContext, useCallback, useContext } from "react";
import { ModalRouterContext, ModalStackItem } from "./ModalRouter_context";
import { MODAL_LIST } from "./ModalRouter_list";
import JSURL from 'jsurl';


export default function ModalRouter({
  children,
}: {
  children: React.ReactNode;
}) {
  const [searchParams, setSearchParams] = useSearchParams();
  const modalStack = searchParams.get('modalStack')
    ? JSURL.parse(searchParams.get('modalStack') || '~(~)') as ModalStackItem[]
    : [];

  const pop = useCallback(() => {
    setSearchParams(prev => {
      let newSearchParams = Object.fromEntries(prev)
      const newModalStack = modalStack.slice(0, -1);
      
      if (newModalStack.length > 0) {
        newSearchParams.modalStack = JSURL.stringify(newModalStack);
      } else {
        delete newSearchParams.modalStack;
      }

      return newSearchParams;
    });
  }, [setSearchParams]);

  const push = useCallback((newModal: Omit<ModalStackItem, 'k'>) => {
    setSearchParams(prev => {
      const currentModalStack = JSURL.parse(prev.get('modalStack') || '~(~)') as ModalStackItem[];
      return {
        ...Object.fromEntries(prev),
        modalStack: JSURL.stringify([
          ...currentModalStack,
          {
            k: Math.random().toString(36).substr(2, 9),
            s: newModal.s,
            a: newModal.a
          }
        ])
      }
    });
  }, [setSearchParams]);

  return (
    <ModalRouterContext.Provider value={{ modalStack, pop, push }}>
      {children}
      {modalStack.map((modalConfig) => {
        const ModalComponent = MODAL_LIST[modalConfig.s].component;
        return <ModalComponent key={modalConfig.k} {...modalConfig.a} />;
      })}
    </ModalRouterContext.Provider>
  );
}